import { useMemo } from 'react';
import L from 'leaflet';

export function useDivIcon(options) {
  return useMemo(() => L.divIcon(options), [options]);
}
